import { CSSProperties } from "@material-ui/core/styles/withStyles";

// constants
import { colors, gradient, greys } from "@styles/color.styles";

export const container: CSSProperties = {
  width: "100%",
  flexShrink: 0,
  backgroundColor: greys.white,
  position: "relative", // make sure content can absolutely position itself, if need be
  borderBottom: `1px solid ${greys.cloudyBlue}`,
};

export const logo = {
  fill: colors.blueDusk.standard,
  style: {
    width: 132,
    flexShrink: 0,
  } as CSSProperties,
};

export const navCollapse = {
  color: greys.slate,
  transform: "rotate(-90deg)",
  height: 34,
  width: 34,
  "&:hover": {
    color: greys.standard,
  },
} as CSSProperties;

export const navContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  height: 60,
  justifyContent: "space-between",
};

export const navCollapseButton = {
  padding: 7,
};

export const gradientBar: CSSProperties = {
  height: 4,
  width: "100%",
  flexShrink: 0,
  background: gradient,
};

export const styles = {
  navCollapse,
};
